const TopBar = ({ children }: { children?: any }) => {
  return (
    <div
      style={{
        width: '100%',
        height: 80,
        // backgroundColor: '#ff0000aa',
        // border: '1px dashed #00ff00aa',
        position: 'absolute',
        top: 0,
      }}
    >
      {children}
    </div>
  )
}

export default TopBar
